<ng-container *transloco="let t">
  @if (showAlertMessage$ | async) {
    <div class="alert-info">
      <span
        ><lib-icon name="alert-triangle" size="x-small" class="me-1"></lib-icon>
        <span [innerHtml]="t('alert_message')"></span
      ></span>
    </div>
  }
</ng-container>
